import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { pageMeta } from "../../utils/metadata";

const PageHelmet = () => {
  const { pathname } = useLocation();
  if (!pageMeta) {
    console.warn("routeMeta is not defined");
    return null;
  }

  let meta = pageMeta[pathname];

  if (!meta) {
    meta = { title: "AdMobilize", description: "Analytics and data management platform." };
    console.warn(`No metadata found for pathname: ${pathname}, using default meta.`);
  }

  return (
    <Helmet>
      <title>{meta.title}</title>

      {meta.description && (
        <meta name="description" content={meta.description} />
      )}

      {meta.noIndex && (
        <meta name="robots" content="noindex,nofollow" />
      )}
    </Helmet>
  );
}

export default PageHelmet;
